import { ChevronLeft, ChevronRight } from 'react-feather'
import { FastlyImage } from '@components/common/image'
import Carousel, { ArrowProps } from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { wrappedYear } from '@pages/wrapped'

const CAROUSEL_DIR = 'images/wrapped/carousel/'

const CustomNavButton = ({
  onClick,
  direction,
}: ArrowProps & { direction: string }) => {
  return (
    <button
      aria-label={`Go to ${direction} slide`}
      className={`react-multiple-carousel__arrow min-h-0 min-w-0 flex items-center justify-center p-0 sm:p-1 md:p-2 ${
        direction === 'previous' ? 'left-0' : 'right-0'
      }`}
      type="button"
      onClick={onClick}
    >
      {direction === 'previous' ? (
        <ChevronLeft size={24} color="white" />
      ) : (
        <ChevronRight size={24} color="white" />
      )}
    </button>
  )
}

const wrappedResponsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1024 },
    items: 1,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 1023, min: 768 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 767, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 463, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const WrappedCarousel = () => {
  const carouselImages = ['1', '2', '3', '4']
  return (
    <div className="py-10 md:py-16">
      <h2 className="container text-3xl sm:text-4xl lg:text-5xl font-600 leading-tight mb-10 text-center mx-auto">
        What’s Inside Codingal Wrapped {wrappedYear}?
      </h2>
      <div className="max-w-6xl mx-auto px-2">
        <Carousel
          responsive={wrappedResponsive}
          autoPlay={true}
          autoPlaySpeed={5000}
          swipeable={true}
          draggable={true}
          showDots={true}
          infinite={true}
          partialVisible={false}
          itemClass="wrapped-carousel-item"
          pauseOnHover={true}
          dotListClass="mt-5 wrapped-carousel-dots"
          sliderClass="px-10"
          containerClass="custom-corousel-container overflow-hidden"
          customLeftArrow={<CustomNavButton direction="previous" />}
          customRightArrow={<CustomNavButton direction="next" />}
        >
          {carouselImages.map((slide, index) => (
            <div key={index} className="flex slider justify-center mb-10">
              <div className="rounded-md overflow-hidden shadow-lg max-w-5xl w-full">
                <FastlyImage
                  src={`${CAROUSEL_DIR}${slide}.jpg`}
                  alt={`Wrapped slide ${slide}`}
                  width={1166}
                  height={375}
                />
              </div>
            </div>
          ))}
        </Carousel>
      </div>

      <style jsx global>{`
        .wrapped-carousel-item {
          display: flex !important;
          justify-content: center;
          align-items: center;
          padding: 0px 30px;
        }

        .wrapped-carousel-dots {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
        }

        .wrapped-carousel-dots li {
          list-style: none;
        }

        .wrapped-carousel-dots li button {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: #d1d5db;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .wrapped-carousel-dots li.react-multi-carousel-dot--active button {
          background-color: #ff5a43;
          width: 8px;
          height: 8px;
        }

        @media (max-width: 640px) {
          .wrapped-carousel-dots li button {
            width: 5px;
            height: 5px;
          }

          .wrapped-carousel-dots li.react-multi-carousel-dot--active button {
            width: 6px;
            height: 6px;
          }
        }

        .react-multiple-carousel__arrow {
          min-height: 0px;
          min-width: 0px;
          transform: translateY(-50%);
        }
      `}</style>
    </div>
  )
}

export default WrappedCarousel
